const cosmetologyLibraries = ['NOUVELLE'];

/**
 * Given an institution code, returns true if the institution is a cosmetology institution,
 * false otherwise.
 *
 * @param {string} institutionCode - The institution code to look up.
 *
 * @returns {boolean} True if the institution is a cosmetology institution, false otherwise.
 */
export const isCosmetology = (instituionCode) => {
	return cosmetologyLibraries.includes(instituionCode);
};
